export const ORGAS_WITH_JOBS_PERMISSION = [
  "-Kr5CZlS7jHaD5WfLalL",
  "QkrhIjNL7vC9mWjfJTui",
  "0VAhS7b0LUKsbE65O331"
];
export const ADMIN_ORGANIZATIONS = ["-Kr5CZlS7jHaD5WfLalL"];

// Add your specific organization for custom fields
export const CUSTOM_FIELDS_ORGANIZATIONS = ["0VAhS7b0LUKsbE65O331"];
